import React from 'react';
import UnknownDumbView from '../../../DeviationViews/Dumbo/Unknown';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import cn from 'classnames';
import { useFreeformSquareSizing } from '../helpers';
import s from './Unknown.scss';
const UnknownMonoView = (props)=>{
    const containerSize = useEditorContainerSize();
    const { deviation, extOptions, width: propsWidth } = props;
    const size = useFreeformSquareSizing(propsWidth, extOptions, containerSize);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], extOptions.smallMedia && s['small'])
    }, /*#__PURE__*/ React.createElement(UnknownDumbView, {
        width: size.width,
        height: size.height,
        deviation: deviation
    }));
};
UnknownMonoView.displayName = 'UnknownMonoView';
export default UnknownMonoView;

//# sourceMappingURL=Unknown.js.map